export default function CTASection() {
  return (
    <section id="contact" className="py-32 bg-gradient-to-br from-teal-50 via-cyan-50 to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-6xl font-bold text-slate-900 mb-8">
          Ready for Your Breakthrough?
        </h2>
        <p className="text-xl text-slate-600 leading-relaxed mb-12 max-w-2xl mx-auto">
          If your operations are constrained by manual processes, disconnected systems, or legacy workflows — BreakthruAI can help.
        </p>

        <div className="flex flex-wrap justify-center gap-6">
          <a
            href="mailto:contact@breakthruai.com"
            className="px-10 py-5 bg-teal-500 text-white text-lg font-medium rounded-full hover:bg-teal-600 transition-all hover:shadow-xl hover:shadow-teal-500/30 whitespace-nowrap cursor-pointer"
          >
            Request a Consultation
          </a>
          <a
            href="mailto:contact@breakthruai.com"
            className="px-10 py-5 bg-white border-2 border-slate-300 text-slate-900 text-lg font-medium rounded-full hover:border-teal-500 hover:text-teal-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Contact Our Team
          </a>
        </div>
      </div>
    </section>
  );
}
